module.exports = __webpack_public_path__ + "static/media/76.d4944506.png";